export default "__VITE_ASSET__48258e71__"